import classNames from 'classnames';
import FJEraseIcon from '../../../assets/svg/erase.svg?react';
import FJDrawIcon from '../../../assets/svg/draw.svg?react';
import PropTypes from 'prop-types';
import styles from './FJBrushCardTwo.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
import FJHoverBoardGradation from '../FJHoverBoard/FJHoverBoardGradation';
import { MOUSE_EVENT_TYPE } from '../../../components/FJMainPreview/FJCreationEditPanel/js/FJViewCanvas';
import FJValueInput from '../FJValueInput/FJValueInput';
import FJSlider from '../FJSlider/FJSlider';

const MAX_SIZE = 100;
const MIN_SIZE = 2;

const FJBrushCardTwo = props => {
    const {
        disabled,
        brashSize = 0,
        curBrushType,

        minBrashSize = MIN_SIZE,
        maxBrashSize = MAX_SIZE,

        isMouseMove,
        isSlideCompare,

        className,

        changeBrushType,
        changeBrashSize,
    } = props;

    const isHideSize = curBrushType !== MOUSE_EVENT_TYPE.MASK_DRAW && curBrushType !== MOUSE_EVENT_TYPE.MASK_ERASE;

    return (
        <div
            className={classNames(
                styles.container,
                styles.object_erase_container,
                disabled && styles.disabled,
                className,
                isHideSize && styles.hide_size_container,
            )}
        >
            <div className={styles.title}>{FJLocalStore._('customize-selection')}</div>
            <div className={classNames(styles.edit_box)}>
                <div className={styles.btu_box}>
                    <div className={styles.erase_edit_btn_box}>
                        <FJHoverBoardGradation
                            className={classNames(styles.edit_btn, {
                                [styles.edit_btn_hover]: !(
                                    curBrushType === MOUSE_EVENT_TYPE.MASK_DRAW &&
                                    !isMouseMove &&
                                    !isSlideCompare
                                ),
                            })}
                            contentClassName={styles.btn}
                            active={curBrushType === MOUSE_EVENT_TYPE.MASK_DRAW && !isMouseMove && !isSlideCompare}
                            onClick={() => changeBrushType(MOUSE_EVENT_TYPE.MASK_DRAW)}
                        >
                            <FJDrawIcon className={styles.draw_icon} />
                            <span className={styles.btn_text}>{FJLocalStore._('draw')}</span>
                        </FJHoverBoardGradation>
                    </div>

                    <FJHoverBoardGradation
                        className={classNames(styles.edit_btn, {
                            [styles.edit_btn_hover]: !(
                                curBrushType === MOUSE_EVENT_TYPE.MASK_ERASE &&
                                !isMouseMove &&
                                !isSlideCompare
                            ),
                        })}
                        contentClassName={styles.btn}
                        active={curBrushType === MOUSE_EVENT_TYPE.MASK_ERASE && !isMouseMove && !isSlideCompare}
                        onClick={() => changeBrushType(MOUSE_EVENT_TYPE.MASK_ERASE)}
                    >
                        <FJEraseIcon className={styles.erase_icon} />
                        <span className={styles.btn_text}>{FJLocalStore._('erase')}</span>
                    </FJHoverBoardGradation>
                </div>

                <div className={classNames(styles.slider_box, isHideSize && styles.hide_size)}>
                    <div className={styles.slider_text}>
                        <div className={styles.slider_text_item}>{FJLocalStore._('size')}</div>
                        <FJValueInput
                            max={maxBrashSize}
                            min={minBrashSize}
                            value={brashSize}
                            changeValue={changeBrashSize}
                            className={styles.slider_input}
                        />
                    </div>
                    <FJSlider
                        className={styles.slider}
                        max={maxBrashSize}
                        min={minBrashSize}
                        value={brashSize}
                        onChange={changeBrashSize}
                    />
                </div>
            </div>
        </div>
    );
};

FJBrushCardTwo.propTypes = {
    active: PropTypes.bool,
    disabled: PropTypes.bool,
    brashSize: PropTypes.number,
    curBrushType: PropTypes.string,
    minBrashSize: PropTypes.number,
    maxBrashSize: PropTypes.number,
    isMouseMove: PropTypes.bool,
    isSlideCompare: PropTypes.bool,
    changeBrushType: PropTypes.func,
    changeBrashSize: PropTypes.func,
    className: PropTypes.string,
};

export default FJBrushCardTwo;
